// scroll overlay
{
    OverlayScrollbars(document.querySelectorAll(".cc-select__listbox"), {clipAlways: false});
}
// product grid thumnail image change 

let thumbnailElements = document.querySelectorAll('.js-product-grid-thumnail-image');
thumbnailElements.forEach(function(thumbnailElement){
    thumbnailElement.addEventListener("mouseenter", _productGridImageChange.bind(this), false);  
    thumbnailElement.addEventListener("click", _productGridColorSwatch.bind(this), false);  
    // thumbnailElement.addEventListener("mouseleave", _mainProductGridImageChange.bind(this), false);  
});
function _productGridImageChange(event){
    let thumbnailImageSrc =  event.currentTarget.querySelector("img").getAttribute("src");
    let mainImage = event.currentTarget.closest(".image-cont ").querySelector(".rimage-wrapper ").querySelector("img");
    
    mainImage.srcset = thumbnailImageSrc;
    let thumbnailImages = event.currentTarget.closest(".product-block__image").querySelectorAll(".js-product-grid-thumnail-image")
    thumbnailImages.forEach(function(thumbnailElement){
        thumbnailElement.classList.remove("active");
    });
    if(!event.currentTarget.classList.contains("active")){ 
        event.currentTarget.classList.add("active");
    }
    let variantOfColorJson = JSON.parse(event.currentTarget.getAttribute("data-variant"));
    let productJson = JSON.parse(event.currentTarget.getAttribute("data-product"));
    if(screen.width > 767){
        if(productJson && variantOfColorJson){
            let productUrl = `/products/${productJson.handle}?variant=${variantOfColorJson.id}`;
            event.currentTarget.closest(".color_option_input").setAttribute("href",productUrl);
        }
    }
    _productGridColorSwatch(event);
}
// function _mainProductGridImageChange(event){
//     let mainImage = event.currentTarget.closest(".image-cont ").querySelector(".rimage-wrapper ").querySelector("img");
//     mainImage.srcset = mainImage.getAttribute("data-srcset");
// }



//Header scroll hide

let header = document.querySelector('.section-header');
let currentSrollTop = window.scrollY;
window.addEventListener("scroll", _headerOnScroll.bind(this),false);
function _headerOnScroll(event){
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if(window.scrollY > currentSrollTop && scrollTop > header.offsetHeight){
        header.classList.add("header-scroll-down");
        header.classList.add("shopify-section-header-sticky");
    } else{
        header.classList.remove("header-scroll-down");       
    }
    currentSrollTop = window.scrollY;
}


// add link in color option
function _productGridColorSwatch(event){
    let colorSwatches = event.currentTarget.closest(".js-main-block").querySelectorAll(".option-selector--swatch")[0];
    if(colorSwatches){
        Array.from(colorSwatches.querySelectorAll(".js-option")).map((colorSwatche) => {
            if(event.currentTarget.querySelector("input")){
                let colorSwatchValue = colorSwatche.getAttribute("value").toLowerCase();
                let hoverSwatchValue = event.currentTarget.querySelector("input").getAttribute("value").toLowerCase();
                if(colorSwatchValue === hoverSwatchValue){
                    colorSwatche.click();
                    colorSwatche.closest(".option-selectors").querySelectorAll(".option-selector")[1].querySelector(".option-selector__btns").querySelector("input").click()

                }
                
            }
        });
    }

//    if(screen.width < 768){
//         let variantOfColorJson = JSON.parse(event.currentTarget.getAttribute("data-variant"));
//         let productJson = JSON.parse(event.currentTarget.getAttribute("data-product"));
//         if(productJson && variantOfColorJson){
//             let productUrl = `/products/${productJson.handle}?variant=${variantOfColorJson.id}`;
//             event.currentTarget.closest(".color_option_input").setAttribute("href",productUrl);
//         }    
//    }
}

// Sticky bar hide and show event
let stickyBarPdp = document.querySelector(".js--sticky-wrapper");
if (stickyBarPdp) {
    window.addEventListener("scroll", function (e) {
        let mainProductTopHeight = (document.querySelector(".container .buy-buttons-row").offsetTop + document.querySelector(".container .buy-buttons-row").offsetHeight) + (document.querySelector("#shopify-section-header").offsetHeight + document.querySelector("#shopify-section-header").offsetTop);

        if ($(document).find(".section-special-product-banner").length) {
            if (window.innerWidth > 767) {
                mainProductTopHeight = (document.querySelector(".section-special-product-banner").offsetHeight) - (document.querySelector("#shopify-section-header").offsetHeight - document.querySelector("#shopify-section-announcement-bar").offsetHeight + 100);
            } else {
                mainProductTopHeight = (document.querySelector(".section-special-product-banner").offsetHeight) - (document.querySelector("#shopify-section-header").offsetHeight - document.querySelector("#shopify-section-announcement-bar").offsetHeight + 200);
            }
        } else {
            mainProductTopHeight = (document.querySelector(".container .buy-buttons-row").offsetTop + document.querySelector(".container .buy-buttons-row").offsetHeight);
        }
        // if (window.pageYOffset >= mainProductTopHeight) {
        //     stickyBarPdp.classList.add("is-sticky");
        // } else {
        //     stickyBarPdp.classList.remove("is-sticky");
        // }
        
    // let stickyHeaderDiv = document.querySelector(".js--sticky-wrapper");
    // if(stickyHeaderDiv){

    //     if(window.scrollY >= 1700){
    //         stickyHeaderDiv.classList.add("is-sticky");
    //     }else{
    //         stickyHeaderDiv.classList.remove("is-sticky");
    //     }
    // }
        if(!!window.IntersectionObserver){
            let intersectionObserverElement = document.querySelector(".js-add-to-cart-button-to-scroll");
            function handler(entries, observer) {
                for (entry of entries) {
                let stickyHeaderDiv = document.querySelector(".js--sticky-wrapper");
                if(entry.isIntersecting === false){

                    stickyHeaderDiv.classList.add("is-sticky");
                }else{
                    stickyHeaderDiv.classList.remove("is-sticky");
                }
                }
            }   
            let observer = new IntersectionObserver(handler);
            observer.observe(intersectionObserverElement);     
        }
    
    });
}

if (document.querySelector(".js-add-to-cart-sticky-button")) {
    let stickAddToCartButton = document.querySelector(".js-add-to-cart-sticky-button");
    stickAddToCartButton.addEventListener("click", _scrollToProductVariant.bind());

    function _scrollToProductVariant() {
        document.querySelector('.addToCart-button').click();
    }
}
let mainQuantityInput = document.querySelectorAll(".js-main-quantity");
if (mainQuantityInput) {
    mainQuantityInput.forEach(function (element) {
        element.addEventListener("click", _updateQuantity.bind(element));
    });

    function _updateQuantity(event){
       
        let quantity = event.target.getAttribute("data-value");
        let stickyQuantity = document.querySelectorAll(".js-sticky-quantity");
        stickyQuantity.forEach(function (sticykQunt) {
             
                sticykQunt.removeAttribute("aria-selected");
          
            if(sticykQunt.getAttribute("data-value") === quantity){
                sticykQunt.setAttribute("aria-selected", true);
                sticykQunt.closest(".cc-select__listbox").setAttribute("aria-activedescendant", `sticky-product-qty-${quantity}`);
                document.querySelector(".js-sticky-quantity-dropdown-button").innerHTML = quantity + '<svg class="cc-select__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
                
            }
        });
       
    }
 
}

// let stickQuantityDropdown = document.querySelectorAll(".js-sticky-quantity");
// if(stickQuantityDropdown){
//     stickQuantityDropdown.forEach(function (stickyQuantityValue) {
//         stickyQuantityValue.addEventListener("click", _updateQuantityOfSticky.bind(this));
//     });
//     function _updateQuantityOfSticky(event){
//         let quantity = event.target.getAttribute("data-value");
//         let mainQuantityInput = document.querySelectorAll(".js-main-quantity");
//         mainQuantityInput.forEach(function (mainQuantity) {
            
//             mainQuantity.removeAttribute("aria-selected");
            
//             if(mainQuantity.getAttribute("data-value") === quantity){
                
//                 mainQuantity.setAttribute("aria-selected", true);
//                 mainQuantity.closest(".cc-select__listbox").setAttribute("aria-activedescendant", `product-qty-${quantity}`);
//                 document.querySelector(".js-main-quantity-dropdown").innerHTML = quantity + '<svg class="cc-select__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
//                 console.log("selectedddddddddddd",event.target.getAttribute("data-value"))
//             }
//         });
//     }
// }
  

$('.featured-collection-landing-rocket__slider.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    dots:false,
    autowidth:true,
    responsive:{
        0:{
            items:1
        },
        1000:{
            items:4
        }
    }
  });
  
  $('.alternate-featured-collection-landing-rocket__slider.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    dots:false,
    autowidth:true,
    responsive:{
        0:{
            items:1
        },
        1000:{
            items:4
        }
    }
  });
  
  $('.landing-collection-slider.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    dots:false,
    autowidth:true,
    responsive:{
        0:{
            items:1
        },
        1000:{
            items:2
        }
    }
  });






